module.exports = __webpack_public_path__ + "static/media/IconUpdatePopUpCloseIcon.c5048638.svg";